/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: gdah8X0wiLGH
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicButtonSecondary.module.css"; // plasmic-import: gdah8X0wiLGH/css

createPlasmicElementProxy;

export const PlasmicButtonSecondary__VariantProps = new Array("textColor");

export const PlasmicButtonSecondary__ArgProps = new Array(
  "onClick",
  "disabled",
  "name",
  "content"
);

const $$ = {};

function PlasmicButtonSecondary__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          disabled: false,
          content: "[ link button ]"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "textColor",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.textColor
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"wrapp"}
      data-plasmic-override={overrides.wrapp}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.wrapp,
        {
          [sty.wrapptextColor_primaryBrand]: hasVariant(
            $state,
            "textColor",
            "primaryBrand"
          ),
          [sty.wrapptextColor_secondary]: hasVariant(
            $state,
            "textColor",
            "secondary"
          ),
          [sty.wrapptextColor_tertiary]: hasVariant(
            $state,
            "textColor",
            "tertiary"
          )
        }
      )}
    >
      <PlasmicLink__
        data-plasmic-name={"link"}
        data-plasmic-override={overrides.link}
        className={classNames(
          projectcss.all,
          projectcss.a,
          projectcss.__wab_text,
          sty.link,
          {
            [sty.linktextColor_primaryGrey]: hasVariant(
              $state,
              "textColor",
              "primaryGrey"
            ),
            [sty.linktextColor_primaryLight]: hasVariant(
              $state,
              "textColor",
              "primaryLight"
            ),
            [sty.linktextColor_secondary]: hasVariant(
              $state,
              "textColor",
              "secondary"
            ),
            [sty.linktextColor_tertiary]: hasVariant(
              $state,
              "textColor",
              "tertiary"
            )
          }
        )}
        disabled={(() => {
          try {
            return $props.disabled;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        name={(() => {
          try {
            return $props.name;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        onClick={async event => {
          const $steps = {};
          $steps["runOnClick"] = true
            ? (() => {
                const actionArgs = { eventRef: $props["onClick"] };
                return (({ eventRef, args }) => {
                  return eventRef?.(...(args ?? []));
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["runOnClick"] != null &&
            typeof $steps["runOnClick"] === "object" &&
            typeof $steps["runOnClick"].then === "function"
          ) {
            $steps["runOnClick"] = await $steps["runOnClick"];
          }
        }}
        platform={"react"}
      >
        <React.Fragment>
          {(() => {
            try {
              return $props.content;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return "continue";
              }
              throw e;
            }
          })()}
        </React.Fragment>
      </PlasmicLink__>
    </div>
  );
}

const PlasmicDescendants = {
  wrapp: ["wrapp", "link"],
  link: ["link"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonSecondary__ArgProps,
          internalVariantPropNames: PlasmicButtonSecondary__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonSecondary__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "wrapp") {
    func.displayName = "PlasmicButtonSecondary";
  } else {
    func.displayName = `PlasmicButtonSecondary.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonSecondary = Object.assign(
  // Top-level PlasmicButtonSecondary renders the root element
  makeNodeComponent("wrapp"),
  {
    // Helper components rendering sub-elements
    link: makeNodeComponent("link"),
    // Metadata about props expected for PlasmicButtonSecondary
    internalVariantProps: PlasmicButtonSecondary__VariantProps,
    internalArgProps: PlasmicButtonSecondary__ArgProps
  }
);

export default PlasmicButtonSecondary;
/* prettier-ignore-end */
